import AxiosInstance from 'src/shared/services/axios/interceptor';
import { MemberUpdateRespons } from 'src/modules/member/models/memberUpdateRespons';
import { PagedResult } from 'src/shared/models/pagedResult';
import { MemberUpdateRequest } from 'src/modules/member/models/memberUpdateRequest';

const controller = 'MemberUpdate';

export const getMemberUpdate = () => {
  // pageIndex, pageSize, sortCol, sortDir, associationId, districtId, searchFilter
  //   let extraQuery = '';
  //   extraQuery += searchFilter ? `&filter=${searchFilter}` : '';
  //   extraQuery += associationId ? `&associationId=${associationId}` : '';
  //   extraQuery += districtId ? `&districtId=${districtId}` : '';
  //   const endpoint = `${controller}/?${setPagingParams({
  //     pageIndex,
  //     pageSize,
  //     sortCol,
  //     sortDir,
  //   })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<MemberUpdateRespons>>(controller);
};

export const getMemberUpdateByMemberId = (memberUpdateId) => {
  const endpoint = `${controller}/${memberUpdateId}`;
  return AxiosInstance.get<MemberUpdateRespons>(endpoint);
};

export const createMemberUpdate = (memberUpdates: MemberUpdateRequest[]) => {
  const endpoint = `${controller}/Set`;
  return AxiosInstance.put<MemberUpdateRespons>(endpoint, memberUpdates);
};
